import { createPopper, popperGenerator, detectOverflow } from "./createPopper.js";
// eslint-disable-next-line import/no-unused-modules
export { createPopper, popperGenerator, detectOverflow };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/popper-base.js
// module id = ./node_modules/@popperjs/core/lib/popper-base.js
// module chunks = 0